import { render, staticRenderFns } from "./OtherFeeDisclaimer.vue?vue&type=template&id=6b652e2e&"
import script from "./OtherFeeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./OtherFeeDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports